<template>
  <div style="width: 100%;">

    <!--主图-->
    <div class="mainImg">
      <img src="../assets/communityDetail.jpg" alt="动态新闻">
    </div>

    <!--标题-->
    <div class="pageTitle">
      <p class="p1">{{article.mainTitle}}</p>
      <p class="p2">来源：{{article.source}}&emsp;&emsp;&emsp;发布时间：{{article.publicDate}}</p>
    </div>

    <!--内容-->
    <div class="inner">
      <ul>
        <li v-for="(value,key) in articleInfo" :key="key">
          <p v-if='value.indexOf("g]")===-1'>{{value}}</p>
          <img v-if='value.indexOf("g]")!==-1'
               :src='value.substring(value.indexOf("[")+1,value.indexOf("]"))'
               style="width: 80%"
               alt="">
        </li>
      </ul>

    </div>

    <!--页脚-->
    <div class="footer">
      <ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
        <li class="info">Copyright © 2017-2020 All rights reserved 版权所有 © 无障碍科技有限公司</li>
        <li class="info">备案号：鄂ICP备18005954号</li>
      </ul>
    </div>

  </div>
</template>

<script>
  import {format} from "../../utils/format.js";
  export default {
    name: "newsDetail",
    data() {
      return {
        article:{},
        articleInfo:[]
      }
    },
    watch:{
      'article':function (res) {
        this.$nextTick(function () {
          this.articleInfo=this.article.content.split("\\n");
          this.article.publicDate = format(res.publicDate);
          // this.articleInfo.push('[https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=3590849871,3724521821&fm=27&gp=0.jpg]');
          // console.log(this.articleInfo[this.articleInfo.length-1].match(/\[(.+?)\g]/g)[0]);
          // let str=this.articleInfo[this.articleInfo.length-1];
          // console.log(str.substring(str.indexOf("[")+1,str.indexOf("]")));
          // console.log(str.indexOf("g]")>-1);
        })
      }
    },
    methods:{
      getData(){
        this.article=this.$route.query.newsItem;
      }//获取产品列表信息
    },
    activated(){
      this.getData();
    }
  }
</script>

<style scoped>
  .mainImg img {
    width: 100%;
    height: 500px;
  }  /*主图*/
  .pageTitle .p1 {
    font-size: 1.6rem;
    font-weight: bold;
    text-align: center;
    padding: 1%;
  }/*标题第一行*/
  .pageTitle .p2 {
    font-size: 0.75rem;
    text-align: center;
    color:rgba(166, 166, 166, 1);
  }/*标题第二行*/
  .inner{
    margin:0 auto;
    text-align: center;
    width: 80%;
    background-color:rgba(69,193,192, 0.1);
  }
  .inner ul{
    list-style:none;
    margin:0 auto;
  }
  .inner li{
    padding: 10px 20px;
    margin-top: 10px;
  }
  .inner p{
    text-align:justify;
    font-size: 1.1rem;
    text-indent: 2em;
    line-height: 2rem;
  }
  .footer{
    background-color: rgba(57, 207, 204, 1);
    text-align: center;
    width: 100%;
    height: 130px;
    float: left;
  }/*页脚*/
  .footer .info{
    color:#fff;
    font-size:0.8rem;
  }/*页脚：里面的内容*/

  /*手机竖屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: portrait){
    .mainImg img{
      height: 200px;
      margin-top:1%;
    }
    .inner img{
      width: 100%;
    }
  }

  /*手机横屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: landscape){
    .mainImg img{
      height: 300px;
      margin-top:1%;
    }
  }

  /*平板竖屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: portrait){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }

  /*平板横屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: landscape){
    .mainImg img{
      height: 400px;
      margin-top:2%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/newsDetail.vue